import * as React from 'react';
import { WizardStepContext } from './WizardModalStepContext';

const useWizardStepContext = () => {
  const context = React.useContext(WizardStepContext);
  if (context === undefined) {
    throw new Error('useWizardStepContext must be used within WizardModalTemplate');
  }
  return context;
};

export default useWizardStepContext;
